<template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0604'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>阶段传感器</h3>
          </div>
          <div class="table-title-btn">
            <el-button type="primary" class="adduser" @click="handleReturn">返回历史参数控制</el-button>
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="设备名称">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.numericalAttrName }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleComparison(scope.row)">比对</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
      </div>
      <el-dialog title="比对折线图" :visible.sync="comparisonDialogVisible" width="1200px" center class="qxtu">
        <div id="mainOne" style="width: 100%; height: 500px; display: inline-block"></div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
// import echarts from 'echarts'
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        id: ''
      },
      total: 0, // 总数
      tableData: [],
      comparisonDialogVisible: false // 比对折线图弹窗是否显示
    }
  },
  created() {
    // 查询
    this.getList()
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        id: ''
      }
      this.getList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getList()
    },
    // 分页获取列表
    getList() {
      this.loading = true
      this.searchForm.id = this.$route.query.hisParamControlId
      this.$api.photosynthesis.getGrowthModelHisParamControlNumericalList(this.searchForm).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.count
        }
      })
    },
    // 比对
    handleComparison(row) {
      this.comparisonDialogVisible = true
      this.getDataHisDataChart(row.numericalId, row.numericalAttrId)
    },
    // 获取历史数据
    getDataHisDataChart(eid, attributeId) {
      this.$api.system.getDataHisDataChart(attributeId, eid, this.$route.query.startTime, this.$route.query.endTime).then(res => {
        if (res.code == 200) {
          let x = []
          let y = []
          let z = []
          for (var i = 0; i < res.data.xTimes.length; i++) {
            x.push(this.$utils.zhDatetime(res.data.xTimes[i]))
          }

          let max = Number(this.$route.query.maxValue)
          let min = Number(this.$route.query.minValue)

          for (var j = 0; j < res.data.yDatas.length; j++) {
            let value = res.data.yDatas[j].value
            y.push(value)

            if (value != undefined && value != null && value != '') {
              value = Number(value)
              if (value > max) {
                max = value
              }

              if (value < min) {
                min = value
              }
            }
          }

          z.push('')
          setTimeout(() => {
            //  执行echarts画图方法
            this.initChart(x, y, z, max, min)
          }, 0)
        }
      })
    },
    // 初始化图表
    initChart(x, y, z, max, min) {
      max = max + 10
      min = min - 10 < 0 ? 0 : min - 10

      var myChart = document.getElementById('mainOne')
      var chartObj = echarts.init(myChart)
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        color: ['#0356fe'],
        legend: {
          data: z,
          textStyle: {
            //图例文字的样式
            color: '#6a7985',
            fontSize: 14
          },
          x: 'center', //可设定图例在左、右、居中
          y: 'bottom'
        },
        xAxis: {
          axisLabel: {
            showMaxLabel: true
          },
          type: 'category',
          // axisLabel:{//倾斜
          //   rotate:-60
          // },
          data: x,
          splitLine: {
            show: false,
            lineStyle: {
              color: ['#ccc'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333',
              width: 1 //这里是为了突出显示加上的
            }
          },
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
            lineStyle: {
              color: ['#ccc'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333',
              width: 1 //这里是为了突出显示加上的
            }
          },
          boundaryGap: false,
          max: max,
          min: min
        },
        series: [
          {
            data: y,
            type: 'line',
            symbol: 'none',
            smooth: true,
            symbolSize: 0,
            lineStyle: {
              color: '#0356fe'
            },
            // areaStyle: {
            //   normal: {
            //     color: "rgba(3,86,254,.3)", //改变区域颜色
            //   },
            // }, // 区域颜色渐变
            markLine: {
              data: [
                { yAxis: this.$route.query.maxValue, name: '最大值' },
                { yAxis: this.$route.query.minValue, name: '最小值' }
              ]
            }
          }
        ],
        grid: {
          x: 30,
          x2: 20,
          y: 20,
          left: '5%',
          right: '5%',
          bottom: '10%'
        }
      }
      chartObj.setOption(option)
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModelHisParamControl`,
        query: {
          decisionId: this.$route.query.decisionId,
          startTime: this.$route.query.startTime,
          endTime: this.$route.query.endTime,
          maxValue: this.$route.query.maxValue,
          minValue: this.$route.query.minValue
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>
